import { useEventBus } from '../runtime';
export function useEventBusDispatcher() {
    const eventBus = useEventBus();
    return (eventName, data) => {
        eventBus.dispatch(eventName, data);
    };
}
